import interactionsSaga from "features/interactions/sagas";
import registrationSaga from "features/registration/registrationSagas";
import { all } from "redux-saga/effects";
import authSaga from "../features/auth/sagas";

export default function* rootSaga() {
  yield all([authSaga(), registrationSaga(), interactionsSaga()]);
}
